function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  id: "backgroundrect",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  fill: "none",
  stroke: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Layer 1");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_227",
  className: "",
  stroke: "#ffffff",
  strokeOpacity: 1,
  strokeWidth: 0
}, React.createElement("circle", {
  fill: "#ff477a",
  r: 19,
  cy: 19.322580337524414,
  cx: 19.322580337524414,
  id: "Ellipse_121",
  stroke: "#ffffff",
  strokeOpacity: 1,
  strokeWidth: 0
}), React.createElement("g", {
  id: "Group_229",
  stroke: "#ffffff",
  strokeOpacity: 1,
  strokeWidth: 0
}, React.createElement("path", {
  className: "cls-2",
  d: "m14.82258066534996,14.82258066534996 l10,10 ",
  id: "Line_3",
  stroke: "#ffffff",
  strokeOpacity: 1,
  strokeWidth: 2
}), React.createElement("path", {
  className: "cls-2",
  d: "m24.82258066534996,14.82258066534996 l-10,10 ",
  id: "Line_4",
  stroke: "#ffffff",
  strokeOpacity: 1,
  strokeWidth: 2
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38,
    style: {}
  }, props), _ref, _ref2, React.createElement("g", {
    style: {},
    className: "currentLayer"
  }, _ref3, _ref4));
};

export default __webpack_public_path__ + "static/media/close.ac95ab7a.svg";
export { SvgComponent as ReactComponent };